import React, {useLayoutEffect} from 'react';
import {Outlet, useLocation} from 'react-router-dom';
import {getContentStudioOnboardingCompleted} from '@/utils/LtidStorage';
import {ROUTES} from '@/config/routesConstants';
import useNavigation from '@/hooks/use-navigation';

/**
 * A route guard component that checks if the user has completed Content Studio onboarding.
 * If onboarding is not completed, it redirects to the onboarding page.
 * Otherwise, it renders the outlet for nested routes.
 */
function ContentStudioOnboardingGuard() {
  const location = useLocation();
  const onboardingCompleted = getContentStudioOnboardingCompleted();

  const {navigate} = useNavigation();

  useLayoutEffect(() => {
    if (
      !onboardingCompleted &&
      location.pathname !== ROUTES.CONTENT_LAB_ONBOARDING
    ) {
      navigate(ROUTES.CONTENT_LAB_ONBOARDING, {replace: true});
    }
  }, [onboardingCompleted, location.pathname]);

  return <Outlet />;
}

export default ContentStudioOnboardingGuard;
